import { Component, ChangeDetectionStrategy, HostBinding, input, computed } from '@angular/core';

import { TranslocoDirective } from '@ngneat/transloco';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { CurrencyFormatPipe, PriceDiscountPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import clsx from 'clsx';

export type ProductPriceLayout =
  | 'product-item'
  | 'presentation-item'
  | 'product-detail'
  | 'product-subtotal'
  | 'option-item'
  | 'resume-item';

@Component({
    selector: 'pxw-product-price',
    templateUrl: './product-price.component.html',
    styleUrls: ['./product-price.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, PriceDiscountPipe, CurrencyFormatPipe, TagComponent]
})
export class ProductPriceComponent {
  layout = input.required<ProductPriceLayout>();
  price = input.required<number>();

  priceDiscount = input<number>();
  maxDiscount = input<number>();
  displayProductPriceWithoutTaxes = input<boolean>(false);

  @HostBinding('class')
  get classNames() {
    return clsx(`layout-${this.layout()}`, {
      'with-discount': this.priceDiscount(),
      'without-taxes': this.displayProductPriceWithoutTaxes(),
    });
  }

  displayPercentage = computed(() => {
    if (this.layout() === 'product-subtotal' || this.layout() === 'resume-item') {
      return false;
    }
    return true;
  });
  currentPrice = computed(() => {
    return this.priceDiscount() || this.price();
  });
  priceWithoutTaxes = computed(() => {
    return Math.round((this.currentPrice() * 100) / 121);
  });
}
